export function Pipe() {
  return <>&nbsp;|&nbsp;</>
}
